/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LeadingStockTrendCellResponse = {
    level1: string;
    trade_date: string;
    main_line_start_date: (string | null);
    trend_state: LeadingStockTrendCellResponse.trend_state;
    level1_rank: (number | null);
    level1_up_count: number;
    level1_up_ratio: (number | null);
};
export namespace LeadingStockTrendCellResponse {
    export enum trend_state {
        CANDIDATE = 'candidate',
        MAIN_LINE = 'main_line',
    }
}

